import React, { useState, useEffect, useRef } from "react";
import { FaChevronCircleRight, FaDownload } from "react-icons/fa";
import { useSelector } from "react-redux";

import { withRouter } from "react-router-dom";

import Paginator, { Loading } from "@/components/Paginator";
import { date } from "@/formatters";
import { ListItem, ActionButton, DownloadButton, Label, ActionsContainer, ModalContent, ModalFooter } from "./styles";
import { Modal, Button } from "@/components/Common";
import { ModalAddAssinante, ModalEditAssinante } from "@/components/Escola";
import { useAssinante } from "@/hooks/assinantes";

import EventEmitter from "@/event-emitter";

function ListarAssinantes({ history }) {
  const [assinantes, setAssinantes] = useState([]);
  const { data: user } = useSelector(state => state.auth);
  const { deleteAssinante, loading: loadingDelete } = useAssinante();
  const [query] = useState({
    empresa_id: user.empresa.id,
  });
  const [paginator, setPaginator] = useState(null);
  const [loadingAssinantes, setLoadingAssinantes] = useState(false);
  const [modalAssinanteOpen, setModalAssinanteOpen] = useState(false);
  const [modalEditAssinanteOpen, setModalEditAssinanteOpen] = useState(false);
  const [assinanteEdit, setAssinanteEdit] = useState([]);
  const [assinanteToDelete, setAssinanteToDelete] = useState(null);
  const paginatorRef = useRef();

  useEffect(() => {
    EventEmitter.subscribe("assinante-added", event =>
      handlePaginatorResetAndFetchData(event)
    );
  }, []);

  function handlePaginatorResetAndFetchData(event) {
    if (paginatorRef.current) {
      paginatorRef.current.resetAndFetchData();
    }
  }

  function handleOnFetchComplete(data) {
    setAssinantes(data.data);
    setPaginator(data.paginator);
  }

  function handleModalEditAssinanteOpen(assinante) {
    setAssinanteEdit(assinante);
    setModalEditAssinanteOpen(true);
  }

  function renderAssinantes() {
    if (assinantes.length > 0) {
      return assinantes.map(assinante => {
        const { id, nome, sobrenome, email, cargo } = assinante;

        return (
          <ListItem key={id}>
            <div className="coluna coluna-nome">
              <h5>Nome</h5>
              <h4>{nome} {sobrenome}</h4>
            </div>

            <div className="coluna coluna-email">
              <h5>Email</h5>
              <h4>{email}</h4>
            </div>

            <div className="coluna coluna-cargo">
              <h5>Cargo</h5>
              <h4>{cargo}</h4>
            </div>

            <div className="coluna coluna-actions">
              <ActionButton
                onClick={() => handleModalEditAssinanteOpen(assinante)}
              >
                <FaChevronCircleRight color="#271946" size={14} />{" "}
                <span>Editar</span>
              </ActionButton>
              <ActionButton
                onClick={() => setAssinanteToDelete(assinante)}
              >
                <span>Remover</span>
              </ActionButton>
            </div>
          </ListItem>
        );
      });
    } else {
      return <Label>Ainda não existem assinantes cadastrados</Label>;
    }
  }

  return (
    <>
      <ActionsContainer>
        <Button
          variant="cyan"
          disabled={loadingAssinantes}
          loading={loadingAssinantes}
          onClick={() => setModalAssinanteOpen(true)}
        >
          Adicionar assinante
        </Button>
      </ActionsContainer>
      <Loading loading={loadingAssinantes}>
        {paginator && renderAssinantes()}
        <Paginator
          endpoint="assinantes"
          query={query}
          onFetchComplete={handleOnFetchComplete}
          onLoading={l => setLoadingAssinantes(l)}
          ref={paginatorRef}
        />
        <Modal
          open={modalAssinanteOpen}
          onClose={() => setModalAssinanteOpen(false)}
        >
          <ModalAddAssinante onClose={() => setModalAssinanteOpen(false)} />
        </Modal>
        <Modal
          open={modalEditAssinanteOpen}
          onClose={() => setModalEditAssinanteOpen(false)}
        >
          <ModalEditAssinante onClose={() => setModalEditAssinanteOpen(false)} assinante={assinanteEdit} />
        </Modal>
        <Modal
          open={!!assinanteToDelete}
          onClose={() => setAssinanteToDelete(null)}
        >
          <ModalContent>
            <h2>Remover assinante</h2>
            <p>
              Deseja remover{" "}
              <strong>
                {assinanteToDelete?.nome} {assinanteToDelete?.sobrenome}
              </strong>{" "}
              da lista de assinantes?
            </p>
            <ModalFooter>
              <Button
                block
                variant="magenta"
                loading={loadingDelete || undefined}
                onClick={() =>
                  deleteAssinante(assinanteToDelete.id, () =>
                    setAssinanteToDelete(null)
                  )
                }
              >
                Confirmar remoção
              </Button>
              <Button
                block
                variant="cancel"
                onClick={() => setAssinanteToDelete(null)}
              >
                Cancelar
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Loading>
    </>
  );
}

export default withRouter(ListarAssinantes);
